<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-row :gutter="20">
          <el-col :span="24">
            <span style="color: burlywood">定价{{ configTitle }}:<span
                style="margin-left: 1%;color: #4d84e2">{{ userName }}</span></span>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="20" style="margin-bottom: 2%;">
        <el-col :span="6">
          <span style="color: #44b1eb">模版选择：</span>
          <el-select v-model="priceMode" clearable placeholder="请选择模版" size="small">
            <el-option
                v-for="item in allPriceMode"
                :key="item.id"
                :label="item.userName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <!--<el-col :span="6">
          <span style="color: #44b1eb">任务类型：</span>
          <el-select v-model="taskType" clearable placeholder="请选择模版" size="small" @change="taskTypeChange">
            <el-option
                v-for="item in taskTypes"
                :key="item.id"
                :label="item.taskName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>-->
        <el-col :span="8">
          <el-button :disabled="isDisabledBtn" type="primary" @click="queryModelData" size="small">获取模版数据</el-button>
          <el-button :disabled="isDisabledBtn" type="primary" @click="updateModelData" size="small">更新模版名称</el-button>
          <el-button type="primary" @click="handleAdd('批量填充费用')" size="small">批量填充费用</el-button>
        </el-col>
      </el-row>
      <div :style="{'height': tableHeight+'px'}">
        <el-scrollbar style="height: 100%">
           <div v-for="(item, index) in tableData" :key="item.taskType.id">
         <el-button type="text">{{item.taskType.taskName}}</el-button>
         <el-table  :data="item.priceData"
                   border default-expand-all stripe
                   :header-cell-style="{'text-align':'center'}"
                    :row-style="{'height':'33px', 'line-height':'33px'}"
                   :cell-style="{'text-align':'center','padding':'0'}"
                   style="width: 100%;margin-bottom: 20px;margin-top: 1%"
                   class="tb-edit"
                   highlight-current-row
                   @row-click="handleCurrentChange">
          <el-table-column prop="id" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="价格区间">
            <el-table-column prop="startPrice" label="起(不含)">
              <!--<template scope="scope">
                <el-input type="number" size="small" v-model="scope.row.startPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.startPrice}}</span>
              </template>-->
            </el-table-column>
            <el-table-column prop="endPrice" label="止(包含)">
              <!--<template scope="scope">
                <el-input type="number" size="small" v-model="scope.row.endPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.endPrice}}</span>
              </template>-->
            </el-table-column>
          </el-table-column>

          <el-table-column label="立返">
            <el-table-column prop="backupServicePriceReference" label="服务费参考">
              <template slot-scope="scope">
                <span>{{ scope.row.backupServicePriceReference }}&nbsp;(零售价:&nbsp;&nbsp;{{ scope.row.backupServicePriceReferenceWeb }}&nbsp;&nbsp;)</span>
              </template>
            </el-table-column>
            <el-table-column label="服务费">
              <template slot-scope="scope">
                <el-form ref="inputForm" :model="scope.row" :rules="rules">
                  <el-form-item prop="backupServicePrice">
                    <el-input type="number" size="small" v-model="scope.row.backupServicePrice" placeholder="请输入内容"
                              @change="handleLocalEdit(scope.$index, scope.row)"></el-input>
                    <span>{{ scope.row.backupServicePrice }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="货返">
            <el-table-column prop="goodReturnServicePriceReference" label="服务费参考">
              <template slot-scope="scope">
                <span>{{ scope.row.goodReturnServicePriceReference }}&nbsp;(零售价:&nbsp;&nbsp;{{ scope.row.goodReturnServicePriceReferenceWeb }}&nbsp;&nbsp;)</span>
              </template>
            </el-table-column>
            <el-table-column label="服务费">
              <template slot-scope="scope">
                <el-form ref="inputForm" :model="scope.row" :rules="rules">
                  <el-form-item prop="goodReturnServicePrice">
                    <el-input type="number" size="small" v-model="scope.row.goodReturnServicePrice" placeholder="请输入内容"
                              @change="handleLocalEdit(scope.$index, scope.row)"></el-input>
                    <span>{{ scope.row.goodReturnServicePrice }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
        </el-scrollbar>
      </div>
      <el-row style="margin-top: 2%;text-align: center">
        <el-col :span="24">
          <el-button type="primary" @click="addSalemanPriceDataInfo">保存</el-button>
          <el-button type="primary" @click="saveSalemanModelData">保存模版</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="30%" center="true">
      <el-form ref="dialogForm" v-model="dialogForm" label-width="180px">
        <el-form-item label="费用加减值: ">
          <el-input type="number" v-model="dialogForm.baseValue" style="width: 50%;"></el-input>
          <div style="color: red;font-size: 5px;">0不变，正数增加，负数减少</div>
        </el-form-item>
        <el-form-item label="取值">
          <el-radio-group v-model="dialogForm.baseValueFlag">
            <el-radio :label="true">成本</el-radio>
            <el-radio :label="false">市场价</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="覆盖非空值">
          <el-radio-group v-model="dialogForm.isCoverValue">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wrihtValueToData" size="mini" type="primary">确认填充</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogModelTitle" :visible.sync="dialogModelFormVisible">
      <el-form ref="dialogModelForm" :model="dialogModelForm" label-width="220px">
        <el-form-item label="模版名称: ">
          <el-input v-model="dialogModelForm.userName" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveAsTemplate" size="mini" type="primary">确认添加模版</el-button>
        <el-button @click="handleCloseModelDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!--添加修改模版名称对话框-->
    <el-dialog :title="dialogModelNameTitle" :visible.sync="dialogModelNameFormVisible">
      <el-form ref="dialogModelNameForm" :model="dialogModelNameForm" label-width="220px">
        <el-form-item label="修改模版名称: ">
          <el-input v-model="dialogModelNameForm.modelName" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateTemplateModeName" size="mini" type="primary">修改模版名称</el-button>
        <el-button @click="handleCloseModelNameDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import {
  addSalemanPriceSetData,
  querySalemanPriceModes,
  querySalemanPriceSetData,
  querySalemanPriceSetModelTemplateData,
  querySalemanPriceSetTemplateData,
  saveSalemanPriceSetTemplate, updateModeNameWithModelId,
  updateSalemanPriceSetData
} from "../../api/b2cbusiness/b2c_saleman";
import {isStrEmpty} from "../../lib/utils";

export default {
  name: "SalemanOrBusinessPriceSetting",
  mixins: [MixinCUD],
  data() {
    const validateInput = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('此项必填！'))
      } else {
        callback()
      }
    }
    return {
      configTitle: "业务员",
      userName: "",
      tableData: [],
      rules: {
        backupServicePrice: [{validator: validateInput, trigger: 'blur'}],
        goodReturnServicePrice: [{validator: validateInput, trigger: 'blur'}],
      },
      priceMode: null,
      modelId:null,
      allPriceMode: [],
      taskType: 1,
      taskTypes: [],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {
        baseValue: 0,
        baseValueFlag: 1,
        isCoverValue: 1,
      },
      priceModeType:null,
      dialogModelFormVisible: false,
      dialogModelTitle: "",
      dialogModelRefName: "dialogModelForm",
      dialogModelForm: {
        userName:null, //模版名称
      },
      //修改模版名称
      dialogModelNameFormVisible: false,
      dialogModelNameTitle: "修改模版名称",
      dialogModelNameRefName: "dialogModelNameForm",
      dialogModelNameForm: {
        modelName:null, //模版名称
      },
      tableHeight: null,
    }
  },
  mounted() {
    getAllTaskType().then(res => {
      if (res.success) {
        this.taskTypes = res.data;
        this.getData();
      }
    });
    this.userName = this.$route.query.userName;
    this.priceModeType = this.$route.query.priceModeType;
    querySalemanPriceModes(this.$route.query.priceModeType, this.taskType).then(res => {
      if (res.success) {
        this.allPriceMode = res.data;
      }
    });
    this.tableHeight = document.body.clientHeight;
  },
  activated() {
    getAllTaskType().then(res => {
      if (res.success) {
        this.taskTypes = res.data;
        this.getData();
      }
    });

    this.userName = this.$route.query.userName != null?this.$route.query.userName:"通用定价";
    this.priceModeType = this.$route.query.priceModeType;
    querySalemanPriceModes(this.$route.query.priceModeType!=null?this.$route.query.priceModeType:this.priceModeType, this.taskType).then(res => {
      if (res.success) {
        this.allPriceMode = res.data;
      }
    });
  },
  computed:{
    isDisabledBtn(){
      return isStrEmpty(this.priceMode);
    }
  },
  methods: {
    //修改模版名称
    updateModelData(){
      this.dialogModelNameFormVisible = true;
    },
    updateTemplateModeName(){
      updateModeNameWithModelId(this.priceMode, this.dialogModelNameForm.modelName).then(res=>{
        if (res.success){
          this.dialogModelNameFormVisible = false;
          querySalemanPriceModes(this.priceModeType, this.taskType).then(res => {
            if (res.success) {
              this.allPriceMode = res.data;
            }
          });
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleCloseModelNameDialog(){
      this.dialogModelNameFormVisible = false;
      for(let item in this.dialogModelNameForm){
        if (typeof this.dialogModelNameForm[item]==='string'){
          this.dialogModelNameForm[item]='';
        } else if (this.dialogModelNameForm[item] instanceof Array) {
          this.dialogModelNameForm[item]=[];
        } else{
          this.dialogModelNameForm[item]=null
        }
      }
    },
    //end
    saveSalemanModelData(){
      for(let item in this.dialogModelForm){
        if (typeof this.dialogModelForm[item]==='string'){
          this.dialogModelForm[item]='';
        } else if (this.dialogModelForm[item] instanceof Array) {
          this.dialogModelForm[item]=[];
        } else{
          this.dialogModelForm[item]=null
        }
      }
      this.dialogModelTitle = "添加或修改模版：";
      this.dialogModelFormVisible = true;
    },
    handleCloseModelDialog(){
      this.dialogModelFormVisible = false;
      for(let item in this.dialogModelForm){
        if (typeof this.dialogModelForm[item]==='string'){
          this.dialogModelForm[item]='';
        } else if (this.dialogModelForm[item] instanceof Array) {
          this.dialogModelForm[item]=[];
        } else{
          this.dialogModelForm[item]=null
        }
      }
    },
    queryModelData(){
      this.tableData = [];
      this.taskTypes.forEach(item=>{
        querySalemanPriceSetModelTemplateData(this.priceMode, item.id).then(res => {
          if (res.success) {
            //this.tableData = res.data;
            this.tableData.push({taskType:item, priceData:res.data});
            this.taskType = item.id;
          }
        }).catch(err => {
          //this.$router.back();
          this.$message({message: err.message, type: 'error'});
        });
      });
    },
    saveAsTemplate(){
      let saveSuccess = true;
      for (let item of this.tableData){
        saveSalemanPriceSetTemplate(item.priceData, this.dialogModelForm.userName, this.$route.query.priceModeType!=null?this.$route.query.priceModeType:this.priceModeType, item.taskType.id).then(res => {

        }).catch(err => {
          saveSuccess = false;
          //this.$router.back();
          this.$message({message: err.message, type: 'error'});
        });
      }
      if (saveSuccess){
        this.dialogModelFormVisible = false;
        this.$message.success("保存模版成功！");
        this.$forceUpdate()
      }
    },
    addSalemanPriceDataInfo() {
      if (this.$route.query.modelId != null){
        this.modelId = this.$route.query.modelId;
        let saveSuccess = false;
        for (let item of this.tableData){
          updateSalemanPriceSetData(item.priceData, this.modelId).then(res => {
            if (res.success) {
              //this.getData();
              saveSuccess = true;
            }
          }).catch(err => {
            saveSuccess = false
            //this.$router.back();
            this.$message({message: err.message, type: 'error'});
          });
        }
        if (saveSuccess){
          this.getData();
          this.$message.success("保存数据成功！");
          this.$forceUpdate();
        }
      }else{
        let addSuccess = true;
        for (let item of this.tableData){
          addSalemanPriceSetData(item.priceData, this.userName, this.$route.query.priceModeType).then(res => {
            if (res.success) {
              this.modelId = res.data;
            }
          }).catch(err => {
            addSuccess = false;
            //this.$router.back();
            this.$message({message: err.message, type: 'error'});
          });
        }
        if (addSuccess){
          this.getData();
        }
      }
    },
    handleCurrentChange(row, event, column) {
      console.log(row, event, column, event.currentTarget)
    },
    handleLocalEdit(index, row) {
      this.resetDialogForm()
      this.dialogForm = {...row}
    },
    getData() {
      console.log(this.$route.query)
      if (this.$route.query.priceModeType == 0) {
        this.configTitle = "业务员"
      } else {
        this.configTitle = "商家"
      }
      this.userName = this.$route.query.userName;
      if (this.$route.query.modelId != null) {
        this.modelId = this.$route.query.modelId;
        this.taskTypes.forEach(item=>{
          querySalemanPriceSetTemplateData(this.$route.query.modelId, item.id).then(res => {
            if (res.success) {
              //this.tableData = res.data;
              this.tableData.push({taskType:item, priceData:res.data});
              this.taskType = item.id;
            }
          }).catch(err => {
            //this.$router.back();
            this.$message({message: err.message, type: 'error'});
          });
        })
      } else {
        this.taskTypes.forEach(item=>{
          querySalemanPriceSetData(this.userName, item.id, this.$route.query.priceModeType).then(res => {
            if (res.success) {
              this.tableData.push({taskType:item, priceData:res.data});
            }
          }).catch(err => {
            //this.$router.back();
            this.$message({message: err.message, type: 'error'});
          });
        })
      }
    },
    wrihtValueToData() {
      //console.log(this.dialogForm)
      this.tableData.forEach(_val1 => {
        _val1.priceData.forEach(_val => {
          _val.b2cTaskTypeId = _val1.taskType.id;
          if (this.dialogForm.baseValueFlag) {
            if (!this.dialogForm.isCoverValue && !isStrEmpty(_val.backupServicePrice)) {
            } else {
              _val.backupServicePrice = _val.backupServicePriceReference + parseInt(this.dialogForm.baseValue);
            }
            if (!this.dialogForm.isCoverValue && !isStrEmpty(_val.goodReturnServicePrice)) {
            } else {
              _val.goodReturnServicePrice = _val.goodReturnServicePriceReference + parseInt(this.dialogForm.baseValue);
            }
          } else {
            if (!this.dialogForm.isCoverValue && !isStrEmpty(_val.backupServicePrice)) {
            } else {
              _val.backupServicePrice = _val.backupServicePriceReferenceWeb + parseInt(this.dialogForm.baseValue);
            }
            if (!this.dialogForm.isCoverValue && !isStrEmpty(_val.goodReturnServicePrice)) {
            } else {
              _val.goodReturnServicePrice = _val.goodReturnServicePriceReferenceWeb + parseInt(this.dialogForm.baseValue);
            }
          }
        })
        this.dialogFormVisible = false;
      })
    },
    taskTypeChange(selVal) {
      //console.log(selVal, this.taskType)
      this.taskType = selVal;
      if (this.$route.query.modelId == null){
        querySalemanPriceSetData(null, this.taskType, this.$route.query.priceModeType).then(res => {
          if (res.success) {
            this.tableData = res.data;
          }
        }).catch(err => {
          this.tableData = [];
          this.$message({message: err.message, type: 'error'});
        });
      }else{
        querySalemanPriceSetTemplateData(this.$route.query.modelId, this.taskType).then(res => {
          if (res.success) {
            this.tableData = res.data;
            this.taskType = this.tableData[0].b2cTaskTypeId;
          }
        }).catch(err => {
          this.$router.back();
          this.$message({message: err.message, type: 'error'});
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table th > .cell {
  text-align: center;
}

/deep/ .el-table .cell {
  text-align: center;
}

span {
  text-align: center;
}

.tb-edit .el-input {
  display: none
}

.tb-edit .current-row .el-input {
  display: block
}

.tb-edit .current-row .el-input + span {
  display: none
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type='number'] {
  -moz-appearance: textfield !important;
}

/deep/ .el-scrollbar__thumb{
  background-color: gray;
}

</style>
